import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative w-full max-w-md mx-auto">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-white border border-background-300/60 rounded-xl text-foreground-950 hover:border-primary-300 transition-colors shadow-sm"
      >
        <span className="flex items-center gap-2 text-sm font-medium">
          <i className="ri-apps-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
          {t('dropdown.title')}
        </span>
        <i className={`${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} w-5 h-5 flex items-center justify-center text-foreground-500 transition-transform`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl border border-background-200/60 shadow-lg max-h-[400px] overflow-y-auto z-40">
          <div className="p-2">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-background-100 transition-colors group"
              >
                <div className="w-8 h-8 rounded-lg overflow-hidden bg-background-100 flex-shrink-0">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <span className="flex-1 text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {t(cat.labelKey)}
                </span>
                <i className="ri-external-link-line w-4 h-4 flex items-center justify-center text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}